<template>
    <navigation class="layout-navigation" :items="navItems"/>
</template>

<style lang="scss">
    .layout-navigation {
        width: $layout-sidebar-width;
    }
</style>

<script>
    export default {
        props: {
            navItems: {type: Array, default: () => []},
        },
    };
</script>